import React from "react";
import { withTranslation } from "react-i18next";
import { format } from "date-fns";

import { Alert, Icon, Badge } from "tabler-react";

function TelegramConnectionStatus({
    t,
    isConnected,
    telegramUsername,
    connectedAt,
}) {
    if (isConnected) {
        const connectionDate = connectedAt ? new Date(connectedAt) : null;
        const formattedDate = connectionDate
            ? format(connectionDate, "PPP p")
            : "";

        return (
            <Alert type="success" hasExtraSpace>
                <div className="d-flex align-items-center">
                    <Icon
                        name="check-circle"
                        className="text-success mr-3"
                        size="lg"
                    />
                    <div className="flex-fill">
                        <h5 className="mb-1">
                            {t("shop.account.telegram.status_connected")}
                            <Badge color="success" className="ml-2">
                                {t("shop.account.telegram.status_active")}
                            </Badge>
                        </h5>
                        <div className="text-muted">
                            {telegramUsername && (
                                <div className="mb-1">
                                    <Icon name="user" className="mr-1" />
                                    <strong>
                                        {t("shop.account.telegram.username")}:
                                    </strong>{" "}
                                    {telegramUsername}
                                </div>
                            )}
                            {connectionDate && (
                                <div>
                                    <Icon name="calendar" className="mr-1" />
                                    <strong>
                                        {t(
                                            "shop.account.telegram.connected_on",
                                        )}
                                        :
                                    </strong>{" "}
                                    {formattedDate}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Alert>
        );
    }

    return (
        <Alert type="warning" hasExtraSpace>
            <div className="d-flex align-items-center">
                <Icon
                    name="alert-circle"
                    className="text-warning mr-3"
                    size="lg"
                />
                <div className="flex-fill">
                    <h5 className="mb-1">
                        {t("shop.account.telegram.status_not_connected")}
                        <Badge color="secondary" className="ml-2">
                            {t("shop.account.telegram.status_inactive")}
                        </Badge>
                    </h5>
                    <div className="text-muted">
                        {t(
                            "shop.account.telegram.status_not_connected_description",
                        )}
                    </div>
                </div>
            </div>
        </Alert>
    );
}

export default withTranslation()(TelegramConnectionStatus);
